export default "__VITE_ASSET__DqTpkmJn__"